// extracted by mini-css-extract-plugin
module.exports = {"deliveryContainer":"CakeShippingPage_deliveryContainer__Cj2Bw"};